document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const overlay = document.querySelector('[data-mobile-overlay]');

  if (!toggle || !overlay) return;

  function open() {
    overlay.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    toggle.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close menu');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    overlay.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    toggle.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', () => {
    if (overlay.classList.contains('is-open')) {
      close();
    } else {
      open();
    }
  });

  overlay.querySelectorAll('[data-mobile-overlay-dismiss]').forEach((el) => {
    el.addEventListener('click', close);
  });

  overlay.querySelectorAll('[data-mobile-menu-close]').forEach((el) => {
    el.addEventListener('click', close);
  });

  overlay.querySelectorAll('a').forEach((a) => {
    a.addEventListener('click', () => {
      close();
    });
  });

  const countrySelect = overlay.querySelector('[data-header-drawer-country-select]');
  if (countrySelect) {
    countrySelect.addEventListener('change', () => {
      const form = countrySelect.closest('form');
      if (form) form.requestSubmit();
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
      close();
    }
  });
});
